$(document).ready(function(){

    // Product addons script

    if($(".product__addons").length){
        // console.log("Addons widget is present");

        // Functions

        const showBlinds = (i) => {
            $(".product__blind").eq(i).show();
            $(".product__blinds").fadeIn(200);
            $("body, html").css("overflow", "hidden");
        }

        const hideBlinds = () => {
            $(".product__blinds").fadeOut(200, function(){
                $(".product__blind").hide();
                $("body, html").css("overflow", "auto");
            });
        }

        const addToForm = () => {
            let inputs_template = "";
            addons.forEach((item, i) => {
                inputs_template += item.checked ? `
                    <input type="hidden" name="items[${i+1}][id]" value="${item.id}">
                    <input type="hidden" name="items[${i+1}][quantity]" value="1">
                ` : "";
            });
            $(".addons--widget__input--wrapper").html(inputs_template);
        }

        // Initialization of widget

        let addons = [];
        $(".product__addon").each(function(){
            const parent = $(this);
            addons.push({id : $(this).attr("data-id"), checked: false});
            $(this).find("input").on("click", function(e){
                e.stopPropagation();
                const addon = addons.filter((item) => item.id == parent.attr("data-id"))[0];
                addon.checked = !addon.checked;
                addToForm();
            });
            const popperInstance = Popper.createPopper($(this).find(".product__addon--tip__icon"), $(this).find(".product__addon--tip"), {
                placement: 'left',
            });
            $(this).find(".product__addon--tip__icon").on("mouseenter", function(){
                parent.find(".product__addon--tip").attr('data-show', '');
                if(parent.find(".product__addon--tip").text().trim() == "") parent.find(".product__addon--tip").css("display", "none");
                popperInstance.update();
            });
            $(this).find(".product__addon--tip__icon").on("mouseleave", function(){
                parent.find(".product__addon--tip").removeAttr('data-show');
            });
        });

        $("product-form form").prepend(`
            <div class="addons--widget__input--wrapper"></div>
        `);

        $(".product__additional").each(function(i){
            $(this).on("click", function(){showBlinds(i)});
        });

        $(".product__blind").each(function(i){
            const parent = $(this);
            $(this).find(".product__blind__addon").each(function(){
                addons.push({id : $(this).attr("data-id"), checked: false});
                $(this).on("click", function(){
                    const variant_id = $(this).attr("data-id");
                    const corresponding_additional = $(".product__additional").eq(i);
                    const additional_title = corresponding_additional.find(".product__additional__selected__title");
                    const blind_title = $(this).find(".product__blind__addon__title");
                    const addon = addons.filter((item) => item.id == variant_id)[0];
                    parent.find(".product__blind__addon").each(function(){
                        if($(this).attr("data-id") == variant_id) return;
                        const addon = addons.filter((item) => item.id == $(this).attr("data-id"))[0];
                        addon.checked = false;
                        $(this).removeClass("selected");
                    });
                    if($(this).hasClass("selected")){
                        addon.checked = false;
                        $(this).removeClass("selected");
                        corresponding_additional.removeClass("selected");
                    } else {
                        addon.checked = true;
                        $(this).addClass("selected");
                        corresponding_additional.addClass("selected");
                        additional_title.text(blind_title.text());
                    }
                    addToForm();
                    hideBlinds();
                });
            });
        });

        // Separate events

        $(".product__additional__selected input[type=checkbox]").on("click", function(e){
            e.preventDefault();
        });

        // $(".product__addon").on("click", function(){
        //     const addon = addons.filter((item) => item.id == $(this).attr("data-id"))[0];
        //     addon.checked = !addon.checked;
        //     $(this).find("input").prop("checked", addon.checked);
        //     addToForm();
        // });

        $(".product__blinds").on("click", hideBlinds);

        $(".product__blind").on("click", function(e){
            e.stopPropagation();
        })

        $(".product__blind__close").on("click", hideBlinds);

        $(".product__blind__addon").on("mouseenter, focus", function(){
            const var_id = $(this).attr("data-id");
            $(`.product__blind__addon__info[data-id=${var_id}]`).fadeIn(200);
        });
        $(".product__blind__addon").on("mouseleave, blur", function(){
            const var_id = $(this).attr("data-id");
            $(`.product__blind__addon__info[data-id=${var_id}]`).fadeOut(200);
        });

    } else {
        console.log("Addons widget is absent");
    }


    // Zip handler add to cart
    if($(".zip-list").length){

        const addToForm = () => {
            let inputs_template = "";
            addons.forEach((item, i) => {
                inputs_template += item.checked ? `
                    <input type="hidden" name="items[${i+1}][id]" value="${item.id}">
                    <input type="hidden" name="items[${i+1}][quantity]" value="1">
                ` : "";
            });
            $(".zip-list__input--wrapper").html(inputs_template);
        }

        // Initialization of widget
        let addons = [];
        $(".zip-list__product").each(function(){
            const parent = $(this);
            addons.push({id : $(this).attr("data-id"), checked: false});
            $(this).find("input").on("click", function(e){
                e.stopPropagation();
                const addon = addons.filter((item) => item.id == parent.attr("data-id"))[0];
                addon.checked = !addon.checked
                addToForm();
            });
            const popperInstance = Popper.createPopper($(this).find(".product__addon--tip__icon"), $(this).find(".product__addon--tip"), {
                placement: 'left',
            });
            $(this).find(".product__addon--tip__icon").on("mouseenter", function(){
                parent.find(".product__addon--tip").attr('data-show', '');
                if(parent.find(".product__addon--tip").text().trim() == "") parent.find(".product__addon--tip").css("display", "none");
                popperInstance.update();
            });
            $(this).find(".product__addon--tip__icon").on("mouseleave", function(){
                parent.find(".product__addon--tip").removeAttr('data-show');
            });
        });

        $("product-form form").prepend(`
            <div class="zip-list__input--wrapper"></div>
        `);


        //  ZIP selector
        const zipNotFound = document.getElementById('zipNotFound');
        let searchService = document.getElementById('searchService');
        let zipList = document.querySelectorAll('.zip-list li');
        let timeout;

        searchService.addEventListener('change', function () {
            let enteredZip = this.value;
            let checker = false;

            // Clear temp form wrapper
            $('.zip-list__input--wrapper').empty();
            // Update checked values from true to false
            addons = addons.map(item=>item.checked==true ? {...item, checked: false} : item );


            clearTimeout(timeout);
            timeout = setTimeout(function () {
                console.log(enteredZip);

                zipList.forEach((item) => {

                // Uncheck all checkboxes on change zip
                $(item).find(".zip-list__checkbox").prop( "checked", false );

                if (item.dataset.zip == enteredZip) {
                    // console.log(item);
                    item.style.display = 'block';
                    checker = true;
                } else {
                    item.style.display = 'none';
                }
                if (searchService.value == '') {
                    checker = true;
                }
                }); //zipList

                zipNotFound.style.display = 'none';
                if (!checker) {
                zipNotFound.style.display = 'block';
                }
            }, 800);
        }); // end Zip selector


    } else {
        console.log("Addons widget is absent");
    }// end  ZIP handler



    // FAQ Section script
    $(".custom-faq-section__question__container, .custom-faq-section__block__question").on("click", function(){
        $(this).parent().toggleClass("active");
        $(this).next().slideToggle(500);
    });

    // QUOTE PAGE FUNCTIONALITY
    $(".quote__title").on("click", function(){
        const title = $(this);
        $(this).next().slideToggle(500, function(){
            title.toggleClass("active");
        });
    });

    // RECLAMATION FORM
    if($(".custom-form-section").length > 0){
        let searchParams = new URLSearchParams(window.location.search);
        let form_value = searchParams.get('form');

        $(".custom-form-section input[type=text]:not(.form-field-text)").each(function(){
            const title = $(this).attr("data-label");
            if(!title) return;
            $(this).val(title);
            $(this).after(`<h3>${title}</h3>`);
        });
        const text_above = $(".text-above-submit").detach();
        $(".custom-form-section button[type=submit]").before(text_above);
        $(".text-above-submit").removeClass("hidden");

        const showForm = () => {
            $(".custom-form-section").slideDown(300, function(){
                $("html, body").animate({scrollTop: $(".custom-form-section").offset().top - 200}, 300);
            });
        }

        $(".custom_form_spawner").on("click", function(){
            showForm();
        });

        $(window).on("load", () => {
            if(form_value == "true") showForm();
        })
    }

    // SUBSIDIES PAGE
    if($(".subsidies__wrapper").length > 0){
        $(".subsidie-read_more").on("click", function(e){
            e.preventDefault();
            $(this).hide();
            $(this).next().slideDown(300)
        });
    }
});